import type {
  BoardStickerFiltersBoardState,
  BoardStickerFiltersSliceState,
} from './boardStickerFilters.types'

import { DEFAULT_TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTER } from '../../lib/taskTrackerBoard.stickerFilters.utils'

export const createEmptyBoardStickerFiltersBoardState =
  (): BoardStickerFiltersBoardState => ({
    draftFilters: {},
    appliedFilters: [],
    completedStatus: DEFAULT_TASK_TRACKER_BOARD_COMPLETED_STATUS_FILTER,
  })

export const createInitialBoardStickerFiltersState =
  (): BoardStickerFiltersSliceState => ({
    byBoardId: {},
  })
